import React, { useEffect } from 'react';
import withTestsService from '../../tests/Tests.service';
import PropTypes from 'prop-types';

function TakeNextMCQModal (props) {
  useEffect(() => {
    // There will be no TakeNextMCQ modal
    if (props.testsService && props.testsService.props.onClose) {
      props.testsService.props.onClose();
    }
  }, [props.testsService]);
  return <div></div>;
}

TakeNextMCQModal.propTypes = {
  testsService: PropTypes.any
};

export default withTestsService(TakeNextMCQModal);
